import isEqual from "lodash/isEqual";
import pick from "lodash/pick";
import { useParams } from "react-router";
import { Policy } from "../types";
import useDerivedPolicyOverride from "./useDerivedPolicyOverride";

interface IUseOverrideWarning {
  policy: Policy;
}

interface UseOverrideWarning {
  overrideWarning: string | undefined;
}

const showDisplayWarning = (
  policy: Policy,
  overrideState: Partial<Policy["override"]>,
) => {
  if (!policy.inherited.enabled && !overrideState?.enabled) return false;
  else
    return !isEqual(
      policy.inherited,
      pick(overrideState, ["blocker", "enabled"]),
    );
};

const useOverrideWarning = ({
  policy,
}: IUseOverrideWarning): UseOverrideWarning => {
  const { groupId } = useParams();
  const { policyOverrideState } = useDerivedPolicyOverride({ policy });

  return {
    overrideWarning:
      showDisplayWarning(policy, policyOverrideState) && Boolean(groupId)
        ? "Overrides organization policy settings."
        : "",
  };
};

export default useOverrideWarning;
